import { arrayToObject } from '@hotglue/common';

const defaultState = {
  selectedEntity: undefined,
  copyEntities: [],
  isLinking: false,
  isFetchingMapping: false,
  mapping: undefined,
  sourceData: undefined
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SELECT_ENTITY':
      newState.selectedEntity = payload;
      return newState;

    case 'COPY_ENTITIES':
      newState.copyEntities = payload;
      return newState;
    case 'SET_IS_LINKING':
      newState.isLinking = payload;
      return newState;
    case 'UPDATE_TENANT_MAPPING':
      newState.mapping = payload?.mapping || {}
      return newState
    case 'FETCH_TENANT_MAPPING':
      newState.isFetchingMapping = status === 'request'
      newState.mapping = payload?.mapping || {}
      newState.sourceData = payload?.source_data
      return newState
  }

  return state;
};
